import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'formattedDate',
  standalone: false
})
export class FormattedDatePipe implements PipeTransform {
  transform(value: string | Date): string {
    if (!value) {
      return '';
    }
    
    const date = moment(value);
    return date.format('MMM D, YYYY');
  }
}